import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { Button, Input, message, Divider, } from 'antd';
import { withTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import Text from 'components/Text';

// Local
import { login } from 'modules/auth/actions';
import { resetEnv } from 'modules/ui/actions';

// Utils
import { post } from 'library/endpoints';

/**
 * AuthFranchise
 * @param {*} props 
 * @returns 
 */
const AuthFranchise = (props) => {
  useEffect(() => {
    if (!props.auth.token) {
      props.resetEnv();
    }
  }, []) // eslint-disable-line

  const [form, setForm] = useState({
    email: null,
    password: null,
  })

  const handleOnSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await post(`frontend/auth/login-franchise`, {
        email: form.email,
        password: form.password,
      })
      window.location.href = `https://${response.data.tenant.subdomain}.ikomiris.eu/autologin/${response.data.autologintoken}`;
    } catch (error) {
      console.log(error)
      message.error(`Identifiants invalides`)
    }
  }
  
  return (
    <>
      <form style={{ maxWidth: 400, margin: 'auto', marginTop: 40 }} onSubmit={handleOnSubmit}>
        <h1>{props.t('Client.Auth.Franchise.Title', `Connexion à l'espace client`)}</h1>
        {props.t('Client.Auth.Franchise.Form.Email', `Adresse E-mail`)}
        <Input placeholder='email' onChange={(e) => setForm({...form, email: e.target.value })}/>

        <div style={{ height: 20 }} />

        {props.t('Client.Auth.Franchise.Form.Password', `Mot de passe`)}
        <Input.Password type="password" placeholder='password' onChange={(e) => setForm({...form, password: e.target.value})}/>

        <div style={{ height: 20 }} />
        <Button type="primary" htmlType="submit" loading={props.auth.loginProcess}>{props.t('Client.Auth.Franchise.Form.Button', `Connexion`)}</Button>
      </form>

      <Divider>ou</Divider>
      <Text align="center">
        <Link to={`/auth/forgot?context=franchise`}>
          {props.t('Client.Auth.Franchise.Forgot', `J'ai oublié mon mot de passe`)}
        </Link>
      </Text>
    </>
  )
}

const stateToProps = state => ({
  auth: state.auth,
})

const dispatchToProps = {
  login,
  resetEnv
}

export default connect(stateToProps, dispatchToProps)(withTranslation()(AuthFranchise));